import { Component, NgZone, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { NumberCardType } from './number-card/number-card.component'
import { DatepickerUpdate } from './datepicker-range/datepicker-range.component';
import { VisitorService, VisitorDataResolution } from '../../services/visitor.service';
import { StoreSelection, Store } from '../../models/store';
import { StoreSelectorService } from '../../services/storeselector.service';
import { Observable, Subscription } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { StoreService } from 'src/app/services/store.service';
// import { StoreHoursService } from 'src/app/services/storehours.service';

// Breakpoint
const isLargeScreenMediaQuery: string = '(min-width: 1350px)';
const PROGRESS_BAR_MODE_INDETERMINATE: string = "indeterminate";

declare var moment: any;

@Component({
	selector: 'analytics',
	templateUrl: './analytics.component.html',
	styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit, OnDestroy {

	numberCardTypeTotal = NumberCardType.Total;
	numberCardTypeAverage = NumberCardType.Total;

	/* Resize layout dynamically */
	show: boolean = true;
	matcher: MediaQueryList;
	resizeListener: any;

	isLargeLayout: boolean = true;
	isLargeDatepicker: boolean = false;

	progressBarMode = PROGRESS_BAR_MODE_INDETERMINATE;
	isLoadingResults: boolean = true;
	datePickerData: DatepickerUpdate;
	hideGraphFromCompare = true;

	/* Show one datepicker of the 3 below */
	currentDatepicker: TemplateRef<any> | null = null;
	@ViewChild('dayDatepicker')
	dayDatepicker: TemplateRef<any> | null = null;
	@ViewChild('monthDatepicker')
	monthDatepicker: TemplateRef<any> | null = null;
	@ViewChild('yearDatepicker')
	yearDatepicker: TemplateRef<any> | null = null;
	@ViewChild('compareComponent')
	compareComponent: TemplateRef<any> | null = null;
	@ViewChild('compareControl') compareControl;

	peopleCount: any = "...";
	totalPeopleCount: any = "...";
	maleCount: any = "...";
	femaleCount: any = "...";
	totalMaleCount: any = "...";
	totalFemaleCount: any = "...";
	autoRenewEnabled: boolean = false;
	storeCount: number = 0;
	useAllStores: boolean = false;
	rangeIncludesToday: boolean = false;
	// storeHours: any;

	private selectedStoreChangesSubscription: Subscription;

	constructor(private breakpointObserver: BreakpointObserver,
		private mediaMatcher: MediaMatcher,
		private zone: NgZone,
		private _visitorService: VisitorService,
		private _storeSelectorService: StoreSelectorService,
		private _storeService: StoreService,
		/*private _storeHoursService: StoreHoursService*/) { }

	ngOnInit() {
		this.currentDatepicker = this.dayDatepicker;
		this.enableResizeListener();

		/* Selected Store */
		// Get initial selected store
		let initSelectedStore: StoreSelection = this._storeSelectorService.getSelectedStore();
		this.onStoreChange(initSelectedStore);

		// Update Selected Store UI when selected store changes
		this.selectedStoreChangesSubscription = this._storeSelectorService.storeChanges.subscribe((newSelectedStore: StoreSelection) => {
			this.onStoreChange(newSelectedStore);
		});
	}

	selectedStore: StoreSelection;

	private onStoreChange(newSelectedStore: StoreSelection) {
		this.selectedStore = newSelectedStore;
		if (this.compareControl != undefined) this.compareControl.reset();
		this.totalPeopleCount = this.peopleCount = "...";
		this.onRefreshClick();
	}

	// Change layout based on isLargeScreenMediaQuery
	enableResizeListener() {
		// On init, check size of viewport and use the appropriately sized layout
		const initIsLargeScreen = this.breakpointObserver.isMatched(isLargeScreenMediaQuery);
		this.changeLayout(initIsLargeScreen);

		// After init, listen to changes in size of viewport
		// and resize to small or large layout when appropriate
		this.resizeListener = (match: MediaQueryList) => {
			// Run the query "in the zone"
			// This is necessary for Angular to realize changes to layout
			this.zone.run(() => {
				// Change layout to match the media query
				this.changeLayout(match.matches);
			})
		};

		this.matcher = this.mediaMatcher.matchMedia(isLargeScreenMediaQuery);
		this.matcher.addListener(this.resizeListener);
	}

	private changeLayout(isLargeLayout: boolean) {
		this.isLargeLayout = isLargeLayout;
	}

	ngOnDestroy() {
		this.matcher.removeListener(this.resizeListener);
		this.selectedStoreChangesSubscription.unsubscribe();
		clearInterval(this.timer);
	}

	selectDay() {
		this.currentDatepicker = this.dayDatepicker;
	}

	selectMonth() {
		this.currentDatepicker = this.monthDatepicker;
	}

	selectYear() {
		this.currentDatepicker = this.yearDatepicker;
	}

	selectCompare() {
		this.currentDatepicker = this.compareComponent;
		this.hideGraphFromCompare = true;
	}

	onRefreshClick() {
		if (this.datePickerData == undefined)
			return;

		this.isLoadingResults = true;
		if (this.currentDatepicker == this.dayDatepicker) {
			//bit of a hack to keep track of current date selection on a  refresh
			var data = this._visitorService.setDateSelection(
				this.datePickerData.fromDate,
				this.getCorrectedToDate(),
				VisitorDataResolution.Day,
				this.useAllStores ? null : this.selectedStore.storeGuid).pipe(
					// mergeMap(() => this._storeHoursService.getStoreHours(this.selectedStore.storeGuid)),
					// map(response => this.storeHours = response),
					mergeMap(() => this._visitorService.getHourlyActivity(moment().startOf('day').add(-6, 'days'), moment().startOf('day').add(1, 'days'), this.useAllStores ? null: this.selectedStore.storeGuid)),
					map(response => this.buildHeatMap(response)),
					mergeMap(() => this._visitorService.getHourlyGenderActivity(moment().startOf('day').add(-6, 'days'), moment().startOf('day').add(1, 'days'), this.useAllStores ? null: this.selectedStore.storeGuid)),
					map(response => this.buildGenderHeatmap(response)),
					mergeMap(() => this._visitorService.getGenderCounts(this.useAllStores ? null : this.selectedStore.storeGuid, 
																		moment().startOf('day'), 
																		this.datePickerData.fromDate,
																		this.getCorrectedToDate())),
					map(response => this.updateGenderCounts(response))
				)

			data.subscribe(() => {
				this.isLoadingResults = false;
			}, (error: any) => {
				console.error(error);
				this.isLoadingResults = false;
			});

			// this.getPeopleCount(false);
		}
		else if (this.currentDatepicker == this.compareComponent) {
			this.compareControl.update();
		}
		else
			this.isLoadingResults = false;
	}

	timer = null;
	lastUpdate = new Date();
	onAutoRenewButtonClick(enable = null) {
		console.log('onAutoRenewButtonClick');
		if (enable == null)
			this.autoRenewEnabled = !this.autoRenewEnabled;
		else
			this.autoRenewEnabled = enable;

		if (this.autoRenewEnabled) {
			this.createTimer();
		} else {
			clearInterval(this.timer);
		}
	}

	createTimer() {
		clearInterval(this.timer);
		this.timer = setInterval(() => {
			if (this.lastUpdate.getDay() == new Date().getDay()) {
				// console.log('Timer get people count')
				this.getPeopleCount(true)
			} else
				this.onRefreshClick();

			this.lastUpdate = new Date();
		}, 15000);
	}

	onDatePickerSizeChange(isLargeDatepicker: boolean) {
		// Hack to avoid ExpressionChangedAfterItHasBeenCheckedError
		Promise.resolve(null).then(() => {
			this.isLargeDatepicker = isLargeDatepicker;
		});
	}

	updatingRange(isUpdating: boolean) {
		this.isLoadingResults = isUpdating;
		this.hideGraphFromCompare = isUpdating;
	}

	private getPeopleCount(createTimer: boolean) {
		if (this.currentDatepicker == this.dayDatepicker && this.rangeIncludesToday) {
			var data = this._visitorService.getVisitorsForToday(this.useAllStores ? null : this.selectedStore.storeGuid, moment().startOf('day')).pipe(
				map(response => this.adjustTotalCount(response, null)),
				mergeMap(() => this._visitorService.getGenderCounts(this.useAllStores ? null : this.selectedStore.storeGuid, 
																	moment().startOf('day'), 
																	this.datePickerData.fromDate,
																	this.getCorrectedToDate())),
				map(response => this.updateGenderCounts(response))
			)
			
			data.subscribe(() => {
				this.isLoadingResults = false;
				if (createTimer)
					this.createTimer();
			}, (error: any) => {
				console.error(error);
				this.isLoadingResults = false;
				if (createTimer)
					this.createTimer();
			});

		}
	}

	private getStoreCount() {
		this._storeService.getStores().then((storeRequest: Observable<Store[]>) => {
			storeRequest.subscribe((stores: Store[]) => {
			  this.storeCount = stores.length;
			}, err => {
			  console.error(err);
			  this.storeCount = 0;
			})
		  })
	}

	getCorrectedToDate() {
		this.rangeIncludesToday = moment(this.datePickerData.toDate) >= moment().startOf('day');
		if (this.rangeIncludesToday) {
			//console.log('using to date: ' + this.datePickerData.toDate);
			//return moment(this.datePickerData.toDate);
			return moment().startOf('day').add(1, 'days').add('-1', 'seconds');
		} else {
			return moment(this.datePickerData.toDate).add(1, 'days').add('-1', 'seconds');
		}
	}

	onRangeDateSelected(dateUpdate: DatepickerUpdate) {
		this.isLoadingResults = true;
		// Send new selected date range and years to compare to the visitor service
		this.datePickerData = dateUpdate;
		var data = this._visitorService.setDateSelection(
			this.datePickerData.fromDate,
			this.getCorrectedToDate(),
			VisitorDataResolution.Day,
			this.useAllStores ? null : this.selectedStore.storeGuid).pipe(
				// mergeMap(() => this._storeHoursService.getStoreHours(this.selectedStore.storeGuid)),
				// map(response => this.storeHours = response),
				mergeMap(() => this._visitorService.getHourlyActivity(moment().startOf('day').add(-6, 'days'), moment().startOf('day').add(1, 'days'), this.useAllStores ? null : this.selectedStore.storeGuid)),
				map(response => this.buildHeatMap(response)),
				mergeMap(() => this._visitorService.getHourlyGenderActivity(moment().startOf('day').add(-6, 'days'), moment().startOf('day').add(1, 'days'), this.useAllStores ? null: this.selectedStore.storeGuid)),
				map(response => this.buildGenderHeatmap(response)),
				mergeMap(() => this._visitorService.getGenderCounts(this.useAllStores ? null : this.selectedStore.storeGuid, 
																	moment().startOf('day'), 
																	this.datePickerData.fromDate,
																	this.getCorrectedToDate())),
				map(response => this.updateGenderCounts(response))
			)

		data.subscribe(() => {
			this.isLoadingResults = false;
		}, (error: any) => {
			console.error(error);
			this.isLoadingResults = false;
		});

		// this.getPeopleCount(false);
		this.getStoreCount();
	}

	heatMapOptions: any;
	hours = ['12a', '1a', '2a', '3a', '4a', '5a', '6a', '7a', '8a', '9a', '10a', '11a', '12p', '1p', '2p', '3p', '4p', '5p', '6p', '7p', '8p', '9p', '10p', '11p'];
	days = ['Saturday', 'Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Monday', 'Sunday'];

	buildHeatMap(counts) {
		var data = [];
		var dow = moment().day();
		var maxValue = 0;
		var hours = this.hours;
		var days = [];
		for (var day = 0; day < 7; day ++) {
			days.push(this.days[((day - dow) + 6) % 7]);
			for (var hour = 0; hour < 24; hour++) {
				let value = counts[((6 - day) * 24) + hour];
				maxValue = Math.max(value, maxValue);
				data.push([hour, day, value == 0 ? null : value ])
			}
		}
		this.heatMapOptions = {
			title: {
				top: 0,
				left: 'center',
				text: 'Activity for last 7 days'
			},
			tooltip: {
				position: 'top',
				formatter: function(info, data, callback) {
					return '<div><div class="tooltip-title">Traffic</div>'+
								'<div>' + days[info.data[1]] + ' ' + hours[info.data[0]] + 'm' + '</div>' + 
							    '<div>' + info.marker + info.data[info.data.length - 1] + '</div></div>'
				}
			},
			animation: false,
			grid: {
				height: '70%',
				y: '10%'
			},
			xAxis: {
				type: 'category',
				data: this.hours,
				splitArea: {
					show: true
				}
			},
			yAxis: {
				type: 'category',
				data: days,
				splitArea: {
					show: true
				}
			},
			visualMap: {
				min: 0,
				max: Math.ceil(maxValue/10) * 10,
				calculable: true,
				orient: 'horizontal',
				left: 'center',
			},
			series: [{
				name: 'Visitors',
				type: 'heatmap',
				data: data,
				label: {
					normal: {
						color: "#444444",
						fontWeight: 'bold',
						show: true
					}
				},
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					}
				}
			}]
		};
	}

	genderHeatmapOptions: any;
	buildGenderHeatmap(counts) {
		var data = [];
		data.push(['hour', 'day', 'value', 'male', 'female']);
		var dow = moment().day();
		var maxValue = 0;
		var hours = this.hours;
		var days = [];
		for (var day = 0; day < 7; day ++) {
			days.push(this.days[((day - dow) + 6) % 7]);
			for (var hour = 0; hour < 24; hour++) {
				let detail = counts[((6 - day) * 24) + hour];
				let total = detail.maleCount + detail.femaleCount;
				let value = 0
				if (total > 0)
					value = Math.round((100 * detail.maleCount) / (detail.maleCount + detail.femaleCount));
				
				maxValue = Math.max(value, maxValue);
				let correctedValue = value;
				if (value == 0 && detail.maleCount + detail.femaleCount == 0)
					correctedValue = null;
					
				data.push([hour, day, correctedValue, detail.maleCount, detail.femaleCount ])
			}
		}
		// console.log(maxValue);
		this.genderHeatmapOptions = {
			title: {
				top: 0,
				left: 'center',
				text: 'Gender % split for last 7 days',
				subtext:  '0% = All Female, 100% = All Male'
			},
			tooltip: {
				position: 'top',
				formatter: function(info, data, callback) {
					return '<div><div class="tooltip-title">Gender Detail</div>'+
								'<div>' + days[info.data[1]] + ' ' + hours[info.data[0]] + 'm' + '</div>' + 
							    '<div>' + info.marker + "Males: " + info.data[3] + " Females: " + info.data[4] + '</div></div>'
				}
			},
			animation: false,
			grid: {
				height: '65%'
			},
			xAxis: {
				type: 'category',
				data: this.hours,
				splitArea: {
					show: true
				}
			},
			yAxis: {
				type: 'category',
				data: days,
				splitArea: {
					show: true
				}
			},
			visualMap: {
				min: 0,
				// max: Math.ceil(maxValue/10) * 10,
				max: 100,
				calculable: true,
				orient: 'horizontal',
				left: 'center',
				dimension: 2,
				text: ['Male', 'Female'],
				inRange: {
					// color: ['#c866da', '#c5c5c5', '#2196f3']
					color: ['#ffa6db', 'white', '#a6beff']
				},
				padding: -40
			},
			dataset: { source: data },
			series: [{
				name: 'Visitors',
				type: 'heatmap',
				label: {
					normal: {
						color: "#444444",
						fontWeight: 'bold',
						show: true
					}
				},
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					}
				}
			}]
		};
	}

	onUseAllStoresClick() {
		this.useAllStores = !this.useAllStores;
		this.onRefreshClick();
	}

	updateTotalCount(counts) {
		this.adjustTotalCount(counts.today, counts.total);
	}

	adjustTotalCount(todayCount: number, totalCount: number) {
		try {
			// console.log('today: ' + todayCount +  "  total: " + totalCount);

			if (totalCount != null)
				this.totalPeopleCount = totalCount;

			if (todayCount != null) {
				let diff = 0;
				if (this.peopleCount != "...")
					diff = todayCount - this.peopleCount;

				this.peopleCount = todayCount;

				if (totalCount == null)
					this.totalPeopleCount += diff;
			}
		} catch (error) {
			this.totalPeopleCount = "...";
		}
	}

	updateGenderCounts(data: any) {
		this.maleCount = data.maleCount;
		this.femaleCount = data.femaleCount;
		this.totalMaleCount = data.maleCountForRange;
		this.totalFemaleCount = data.femaleCountForRange;
		this.updateGenderPieChart(data);
	}

	genderPiechartOptionsDay: any;
	genderPiechartOptionsRange: any;
	updateGenderPieChart(data: any) {
		console.log(data);
		var dayData = [{ name: 'Male', value: data.maleCount }, { name: 'Female', value: data.femaleCount }];
		var rangeData = [{ name: 'Male', value: data.maleCountForRange }, { name: 'Female', value: data.femaleCountForRange }];

		this.genderPiechartOptionsDay = {
			title: [{ text: 'Today', left: 'center' }],
			series: [{
				type: 'pie',
				radius: '65%',
				label: {
					color: '#000000',
					position: 'inner',
					fontWeight: 'bold',
					formatter: '{b}: {c} ({d}%)'
				},
				data: dayData,
				color: ['#78a1ff', '#ffa6db']
			}]
		}

		this.genderPiechartOptionsRange = {
			title: [{ text: 'Selected Range', left: 'center' }],
			series: [{
				type: 'pie',
				radius: '65%',
				label: {
					color: '#000000',
					position: 'inner',
					fontWeight: 'bold',
					formatter: '{b}: {c} ({d}%)'
				},
				data: rangeData,
				color: ['#78a1ff', '#ffa6db']
			}]
		}
	}
}
